export function parseKulissenpreisCsv(csv) {
  let arr = csv.split('\r');
  let jsonObj = [];
  let headers = arr[0].split(';');
  for (let i = 1; i < arr.length; i++) {
    let data = arr[i].split(';');
    let obj = {};

    for (let j = 0; j < data.length; j++) {
      obj[headers[j].trim()] = data[j].trim();
    }
    jsonObj.push(obj);
  }
  JSON.stringify(jsonObj);
  return jsonObj;
}

export function calculateDelta(x, y) {
  let delta = x - y;
  return delta;
}

export function getMinTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2) {
  let min = daten
    .filter((x) => x['Typ'] === Muss1 && parseFloat(x['Dicke']) === Muss2)
    .sort((a, b) => a[Xname] - b[Xname] || a[Yname] - b[Yname])
    .find((x) => Math.min(x[Xname]) >= XSoll && Math.min(x[Yname]) >= YSoll);

  return min;
}

export function getMaxTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2) {
  let max = daten
    .filter((x) => x['Typ'] === Muss1 && parseFloat(x['Dicke']) === Muss2)
    .sort((a, b) => b[Yname] - a[Yname] || b[Xname] - a[Xname])
    .find((x) => Math.max(x[Xname]) <= XSoll && Math.max(x[Yname]) <= YSoll);
  return max;
}

export function getDeltaWert(daten, xSoll, ySoll, Xname, Yname, Dname, musskriterium1, musskriterium2) {
  let XSoll = parseFloat(xSoll);
  let YSoll = parseFloat(ySoll);

  let min = getMinTuple(daten, XSoll, YSoll, Xname, Yname, musskriterium1, musskriterium2);
  let max = getMaxTuple(daten, XSoll, YSoll, Xname, Yname, musskriterium1, musskriterium2);
  if (min === undefined || max === undefined) {
    return 0;
  }
  else {
    let deltaX = 0;
    let deltaXSoll = 0;
    let deltaY = 0;
    let deltaYSoll = 0;
    let deltaD = 0;
    let d1 = 0;
    let d = 0;

    deltaX = calculateDelta(parseFloat(max[Xname]), parseFloat(min[Xname]));
    deltaXSoll = calculateDelta(parseFloat(XSoll), parseFloat(min[Xname]));
    deltaY = calculateDelta(parseFloat(max[Yname]), parseFloat(min[Yname]));
    deltaYSoll = calculateDelta(parseFloat(YSoll), parseFloat(min[Yname]));
    deltaD = parseFloat(max[Dname]) - parseFloat(min[Dname]);
    d1 = parseFloat(min[Dname]);

    if (isNaN(Math.pow((deltaXSoll / deltaX), 2))) {
    }
    if (isNaN(Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2))) {
    }
    if (deltaD === 0) {
      return d1;
    }
    let deltaDIVX = 0;
    if (isNaN((deltaXSoll / deltaX))) {
      deltaDIVX = 0;
    }
    else {
      deltaDIVX = Math.pow((deltaXSoll / deltaX), 2);
    }

    let deltaDIVY = 0;
    if (isNaN((deltaYSoll / deltaY))) {
      deltaDIVY = 0;
    }
    else {
      deltaDIVY = Math.pow((deltaYSoll / deltaY), 2);
    }

    let calc = Math.sqrt(deltaDIVX + deltaDIVY);
    d = d1 + deltaD * calc;

    return d;
  }
}

export function calculateKulissenpreisJeStueck({ kulissenpreisDaten, Kulissenhoehe, Kulissenlaenge, Kulissentyp, Kulissenbreite }) {
  let daten = kulissenpreisDaten;
  let Xname = 'Hoehe';
  let Yname = 'Laenge';

  let xSoll1 = parseFloat(Kulissenhoehe);
  let ySoll1 = parseFloat(Kulissenlaenge);
  let musskriterium1 = Kulissentyp;
  let musskriterium2 = parseFloat(Kulissenbreite);
  let d = getDeltaWert(daten, xSoll1, ySoll1, Xname, Yname, 'Preis', musskriterium1, musskriterium2);

  return d;
}

export function calculateSchalldaempferGehaeuseflaeche({ Schalldaempferlaenge, Schalldaempferhoehe, Schalldaempferbreite }) {
  let flaeche = (((Schalldaempferbreite / 1000) + (Schalldaempferhoehe / 1000)) * 2 * Schalldaempferlaenge / 1000);
  if (flaeche < 1) {
    return 1;
  }
  else {
    return flaeche;
  }
}

export function calculateSchalldaempferGehaeusepreis(props) {
  return calculateSchalldaempferGehaeuseflaeche(props) * 40;
}

export function calculateZusammenbaupreisJeKulisse() {
  return 58;
}

export function calculateZusatzoptionenpreisJeKulisse({ KulissenpreisNetto, Rabatt, Optionen, Kulissenbreite, Kulissenlaenge, Kulissenhoehe }) {
  let d = 0;
  let rabattpreis = 0;
  if (KulissenpreisNetto > 0) {
    if (Rabatt > 0) {
      rabattpreis = KulissenpreisNetto - (KulissenpreisNetto * Rabatt / 100);
    }
    else {
      rabattpreis = parseFloat(KulissenpreisNetto);
    }

    if (Optionen[0].isChecked) {
      d = rabattpreis * 0.5;
    }
    if (Optionen[1].isChecked) {
      d = d + (Math.sqrt(Kulissenbreite / 100) * Kulissenlaenge / 1000 * 16);
    }
    if (Optionen[2].isChecked) {
      d = d + (Math.sqrt(Kulissenbreite / 100) * Kulissenhoehe / 1000 * 16);
    }
  }
  return d;
}

export function calculatePreisVorRabatt({ kanalpreis, kulissenpreis, anzahlKulissen }) {
  let teuerungszuschlag = 0;
  let zusammenbau = calculateZusammenbaupreisJeKulisse();
  let preis = kanalpreis + (anzahlKulissen * kulissenpreis) + (anzahlKulissen * zusammenbau) + teuerungszuschlag;
  return preis;
}

export function calculateRabattierterPreis(preis, rabatt) {
  if (rabatt > 0) {
    return preis - (preis * rabatt / 100);
  }
  return preis;
}

export function calculateGesamtpreisNettoNachRabatt({
  Schalldaempferlaenge,
  Schalldaempferhoehe,
  Schalldaempferbreite,
  AnzahlKulissen,
  Rabatt,
  kulissenpreis,
  preisZusatzoptionenKulisse,
}) {
  let kanalpreis = calculateSchalldaempferGehaeusepreis({
    Schalldaempferlaenge,
    Schalldaempferhoehe,
    Schalldaempferbreite,
  });
  let preis = calculatePreisVorRabatt({ kanalpreis, kulissenpreis, anzahlKulissen: AnzahlKulissen });

  if (kulissenpreis === 0) {
    return 0;
  }
  else {
    if (Rabatt > 0) {
      let rabattpreis = calculateRabattierterPreis(preis, Rabatt);
      rabattpreis += (preisZusatzoptionenKulisse * AnzahlKulissen);
      return rabattpreis;
    }
    else {
      preis += (preisZusatzoptionenKulisse * AnzahlKulissen);
      return preis;
    }
  }
}

export function calculatePricing({ kulissenpreisDaten, Optionen, ...props }) {
  let kulissenpreis = calculateKulissenpreisJeStueck({
    kulissenpreisDaten,
    Kulissenhoehe: props.Schalldaempferhoehe,
    Kulissenlaenge: props.Schalldaempferlaenge,
    Kulissentyp: props.Kulissentyp,
    Kulissenbreite: props.Kulissenbreite,
  });
  let preisZusatzoptionenKulisse = calculateZusatzoptionenpreisJeKulisse({
    KulissenpreisNetto: kulissenpreis,
    Rabatt: props.Rabatt,
    Optionen,
    Kulissenbreite: props.Kulissenbreite,
    Kulissenlaenge: props.Schalldaempferlaenge,
    Kulissenhoehe: props.Schalldaempferhoehe,
  });
  let gehaeusepreis = calculateSchalldaempferGehaeusepreis(props);
  let preisVorRabatt = calculatePreisVorRabatt({
    kanalpreis: gehaeusepreis,
    kulissenpreis,
    anzahlKulissen: props.AnzahlKulissen,
  });
  let priceNetAfterDiscount = calculateGesamtpreisNettoNachRabatt({
    ...props,
    kulissenpreis,
    preisZusatzoptionenKulisse,
  });

  return {
    gehaeusepreis,
    kulissenpreis,
    zusammenbaupreisJeKulisse: calculateZusammenbaupreisJeKulisse(),
    preisZusatzoptionenKulisse,
    preisVorRabatt,
    priceNetAfterDiscount,
  };
}
